module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/loading-e9bea0c219ca77777cbadce2d34b09a7.gif";